import { useRouter } from 'next/router';
import type { IdentityRequest } from '$api-clients/hooks';
import { useAppFlags } from '$launchdarkly/useAppFlags';

export function useTeamId(
  userInfo: IdentityRequest<'/auth/userinfo'>['Data'] | undefined,
  agentTeamId: string | undefined,
) {
  const router = useRouter();
  const { identityUpdateRoles } = useAppFlags();

  if (!identityUpdateRoles) {
    return router.query.team?.toString() ?? agentTeamId;
  }

  if (!userInfo) {
    return undefined;
  }
  const rootTeamId = userInfo?.teams.find((t) =>
    userInfo?.accessibleTeams?.roots.includes(t.id),
  )?.id;
  const anyAccessibleTeamId = userInfo?.teams.find(
    (t) => userInfo?.accessibleTeams?.nodes[t.id],
  )?.id;

  // if no team id in the query, use the root team id or any accessible team id
  return router.query.team?.toString() ?? rootTeamId ?? anyAccessibleTeamId;
}
